export class Troubleshootingqabox {
  sn: number = null;
  name: string = "";
  desc: string = "";
  id: string = null;

  getSn() {
    return this.sn;
  }

  getName() {
    return this.name;
  }

  getId() {
    return this.id;
  }

  getDesc() {
    return this.desc;
  }

  setSn(sn: number) {
    this.sn = sn;
  }

  setName(name: string) {
    this.name = name;
  }

  setId(id: string) {
    this.id = id;
  }

  setDesc(desc: string) {
    this.desc = desc;
  }
}
